import { render, staticRenderFns } from "./Env.vue?vue&type=template&id=672b0830&scoped=true&"
import script from "./Env.vue?vue&type=script&lang=js&"
export * from "./Env.vue?vue&type=script&lang=js&"
import style0 from "./Env.vue?vue&type=style&index=0&id=672b0830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b0830",
  null
  
)

export default component.exports